import { client } from '../client';

export interface Payload {
  method: string;
  user_credentials: { email: string; password: string };
  mfa_code: string;
  session: string;
  client?: string;
  client_access_code?: string;
  organization_id: string;
  division_id?: string;
  practice_id?: string;
}

export interface VerifyMfaCodeResponse {
  access_token: string;
  refresh_token: string;
  role?: string;
  redirect_url?: string;
}
export const verifyMfaCode = async (payload: Payload): Promise<VerifyMfaCodeResponse> => {
  const { data } = await client.post<VerifyMfaCodeResponse>(`/auth/mfa/verify_code`, payload);

  return data;
};
